import type { PlanStepProps } from './PlanStep';

export const planStepData: PlanStepProps[] = [
  {
    step: 1,
    title: 'Tell us about your dog',
    description: `Our plans are tailored to your dog’s needs, based on their age, weight, activity level, body condition and other factors.`,
  },
  {
    step: 2,
    title: 'Choose your recipes',
    description: `Pick the recipes that work best for your pup, and wait for your trial box to arrive (and the dinnertime dancing to commence).`,
  },
  {
    step: 3,
    title: 'Get your trial box',
    description: `Your trial contains up to 2 weeks of food, so you can get a proper taste of how it’s working for your dog before your first full order ships.`,
  },
  {
    step: 4,
    title: 'Start feeding fresh',
    description: `After you’ve had a chance to try (and love) it, start getting perfectly timed deliveries of fresh, healthy food.`,
  },
];
